<template>
  <component-wrapper>
    <div
      :class="{
        'teaser-big-image-slider-fi': true,
        'teaser-big-image-slider-fi--exp': isEditMode,
        'teaser-big-image-slider-fi--dark': isDarkBackground,
        'teaser-big-image-slider-fi--light': isLightBackground,
      }"
    >
      <div
        v-if="isEditMode"
        class="teaser-big-image-slider-fi__exp-info"
      >
        <icon-fi icon="alert-triangle" /> COMPONENT ONLY EDITABLE IN CONTENT EDITOR
      </div>

      <grid-container-fi :container="false">
        <div class="fi-col-span-12 fi-col-start-1">
          <carousel-fi
            v-if="
              fields.teaserBigImageSliderElements && fields.teaserBigImageSliderElements.length > 1
            "
            ref="carousel"
            theme="teaser-big-image"
            @before-change="beforeSlideChanged"
            @after-change="afterSlideChanged"
          >
            <carousel-slide-fi
              v-for="(teaserBigImage, index) in fields.teaserBigImageSliderElements"
              :key="'teaser-big-image-slider-fi__slide--' + index"
            >
              <teaser-big-image-slider-element-fi
                class="teaser-big-image-slider-fi__slide"
                :slide-changed="slideIsChanging"
                :fields="{
                  ...teaserBigImage.fields,
                  darkBackground: { value: isDarkBackground },
                  lightBackground: { value: isLightBackground },
                  imagePosRight: { value: isImagePosRight },
                  bigImageSize: { value: isBigImage },
                }"
              />
            </carousel-slide-fi>
          </carousel-fi>

          <div
            v-else-if="
              (!fields.teaserBigImageSliderElements ||
                fields.teaserBigImageSliderElements.length < 2) &&
              isEditMode
            "
            class="teaser-big-image-slider-fi__xpe-hint"
          >
            <icon-fi :icon="'alert-triangle'" />
            {{ $options.name }}: Please add at least two slides to this slider
          </div>
        </div>
      </grid-container-fi>
    </div>
  </component-wrapper>
</template>

<script>
import { CarouselFi, CarouselSlideFi, IconFi } from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import TeaserBigImageSliderElementFi from '@/components/teaser/teaser-big-image-slider-element-fi/TeaserBigImageSliderElementFi.vue';
import breakpointMixin from '@/mixins/breakpointMixin.vue';

export default {
  name: 'TeaserBigImageSliderFi',
  components: {
    IconFi,
    GridContainerFi,
    ComponentWrapper,
    TeaserBigImageSliderElementFi,
    CarouselFi,
    CarouselSlideFi,
  },
  mixins: [breakpointMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      slideIsChanging: false,
    };
  },
  computed: {
    isDarkBackground() {
      return this.fields.darkBackground?.value;
    },
    isLightBackground() {
      return this.fields.lightBackground?.value;
    },
    isBigImage() {
      return this.fields.bigImageSize?.value;
    },
    isImagePosRight() {
      return this.fields.imagePosRight?.value;
    },
  },
  methods: {
    beforeSlideChanged() {
      this.slideIsChanging = true;
    },
    afterSlideChanged() {
      this.slideIsChanging = false;
    },
  },
};
</script>

<style scoped src="./teaser-big-image-slider-fi" />

<style src="./teaser-big-image-slider-fi-unscoped" />
